@if (showLdr) {
<ds-loading></ds-loading>
}

<!-- Modern Header Section -->
<div
  class="relative bg-gradient-to-br from-slate-50 via-teal-50 to-cyan-50 shadow-xl border-b-4 border-teal-200 mb-4 overflow-hidden cstmmrgin"
>
  <div class="absolute inset-0 opacity-5">
    <div
      class="absolute top-0 left-0 w-96 h-96 bg-teal-500 rounded-full blur-3xl"
    ></div>
    <div
      class="absolute bottom-0 right-0 w-96 h-96 bg-cyan-500 rounded-full blur-3xl"
    ></div>
  </div>
  <div class="relative flex items-center justify-between px-8 py-2">
    <div class="flex-1">
      <div class="flex items-center gap-3">
        <div
          class="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-teal-500 to-cyan-600 rounded-xl shadow-lg flex items-center justify-center"
        >
          <svg
            class="w-6 h-6 text-white"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
            ></path>
          </svg>
        </div>
        <div>
          @if (clntDtls && clntDtls.length > 0 && clntDtls[0].clnt_id==7) {
          <h1
            class="text-xl font-bold bg-gradient-to-r from-teal-600 via-cyan-600 to-teal-600 bg-clip-text text-transparent mb-0"
          >
            Trip Wise Coverage Status @if (selectedtenantNm) {
            <span class="text-base text-cyan-600 font-semibold ml-1"
              >- {{ selectedtenantNm }} - {{ selectedSvm }}</span
            >
            }
          </h1>
          }
          <p class="text-sm text-gray-500 font-medium mb-1">
            Ward Level Coverage Analytics
          </p>
        </div>
      </div>
    </div>
    <div class="flex items-center gap-3">
      <div class="flex flex-col min-w-0">
        <nz-date-picker
          [nzDisabledDate]="disabledDate"
          [nzFormat]="dateFormat"
          [(ngModel)]="slctdDt"
          (ngModelChange)="onChange($event)"
          class="filter-input"
        ></nz-date-picker>
      </div>
      @if (vehclesLst && vehclesLst.length>1) {
      <div class="flex flex-col min-w-0" style="min-width: 180px">
        <nz-select
          nzShowSearch
          nzAllowClear
          nzPlaceHolder="Select Vehicle"
          (ngModelChange)="onasrtgetSelected($event)"
          [(ngModel)]="selectedVehicle"
          style="width: 100%"
        >
          @for (a of vehclesLst; track a) {
          <nz-option [nzValue]="a.asrt_id" [nzLabel]="a.asrt_nm"> </nz-option>
          }
        </nz-select>
      </div>
      } @if (vehclesLst && vehclesLst.length==1) {
      <span class="text-xs text-gray-500 font-medium">
        Vehicle:
        <span class="text-teal-600 font-semibold">{{
          vehclesLst[0].asrt_nm
        }}</span>
      </span>
      }
      <button
        (click)="goBack()"
        class="flex items-center gap-1.5 px-4 py-2 bg-gradient-to-r from-rose-500 to-red-600 hover:from-rose-600 hover:to-red-700 text-white rounded-lg transition-all duration-200 shadow-sm text-sm font-medium cursor-pointer border-0"
      >
        <span nz-icon nzType="left" nzTheme="outline"></span>
        Go Back
      </button>
    </div>
  </div>
  <div
    class="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-teal-400 via-cyan-500 to-teal-500"
  ></div>
</div>

<div class="mx-auto px-3">
  <!-- Summary Strip -->
  @if (tdyCoveredTrips && tdyCoveredTrips.length > 0) {
  <div class="ward-summary-strip">
    @for (d of tdyCoveredTrips; track d) {
    <div class="ward-summary-item">
      <div class="ward-item-icon bg-teal">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4"
          ></path>
        </svg>
      </div>
      <div class="ward-item-value">
        {{ d.TOT_VEHICLES === null ? "0" : d.TOT_VEHICLES }}
      </div>
      <div class="ward-item-label">Total Vehicles</div>
    </div>
    }
    <div class="ward-strip-divider"></div>
    @for (d of tdyCoveredTrips; track d) {
    <div class="ward-summary-item">
      <div class="ward-item-icon bg-emerald">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M11 3.055A9.001 9.001 0 1020.945 13H11V3.055z"
          ></path>
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M20.488 9H15V3.512A9.025 9.025 0 0120.488 9z"
          ></path>
        </svg>
      </div>
      <div class="ward-item-value">
        {{ d.coverage_per === null ? 0 : d.coverage_per }}%
      </div>
      <div class="ward-item-label">Coverage %</div>
    </div>
    }
    <div class="ward-strip-divider"></div>
    <div class="ward-summary-item">
      <div class="ward-item-icon bg-cyan">
        <svg
          class="w-5 h-5"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6"
          ></path>
        </svg>
      </div>
      <div class="ward-item-value">
        {{ rdrctSvmDtls.dist === null ? "0" : rdrctSvmDtls.dist }}
        <span class="ward-item-unit">Km</span>
      </div>
      <div class="ward-item-label">Total Distance</div>
    </div>
  </div>
  }

  <!-- Vehicle wise Trip Coverage Table -->
  <div class="ward-section-card">
    <div class="ward-section-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-teal-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M3 10h18M3 14h18m-9-4v8m-7 0h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z"
          ></path>
        </svg>
        <h2 class="ward-section-title">Vehicle wise Trip Coverage Status</h2>
      </div>
    </div>
    <div class="ward-grid-section">
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="tripsData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="true"
        exportFileName="Ward Secretariat wise Trip Coverage Status"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
        [wordWrapEnabled]="false"
        scrollX="1730px"
      >
      </app-data-grid>
    </div>
  </div>

  <!-- Map Section -->
  <div class="ward-section-card" #pdfContent>
    <div class="ward-section-header">
      <div class="flex items-center gap-2">
        <svg
          class="w-5 h-5 text-teal-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7"
          ></path>
        </svg>
        @if (shwCvrge) {
        <h2 class="ward-section-title">Coverage of {{ slctdVehNm }}</h2>
        } @if (!shwCvrge) {
        <h2 class="ward-section-title">Playback of {{ slctdVehNm }}</h2>
        }
      </div>
      <div class="flex items-center gap-4">
        <!-- Map Mode Toggle -->
        <div class="ward-map-toggle">
          <label
            nz-checkbox
            [(ngModel)]="shwCvrge"
            (ngModelChange)="onChkCoverage($event)"
            class="ward-chk-label"
            >Coverage</label
          >
          <label
            nz-checkbox
            [(ngModel)]="shwplyback"
            (ngModelChange)="onChkPlyback($event)"
            class="ward-chk-label"
            >Playback</label
          >
        </div>
        <!-- Legend -->
        @if (shwCvrge) {
        <div class="ward-map-legend">
          <div class="ward-legend-item">
            <span class="ward-legend-dot bg-green-500"></span>
            <span class="ward-legend-text">Covered Area</span>
          </div>
          <div class="ward-legend-item">
            <span class="ward-legend-dot bg-red-500"></span>
            <span class="ward-legend-text">Not Covered Area</span>
          </div>
        </div>
        } @if (!shwCvrge) {
        <div class="ward-map-legend">
          <div class="ward-legend-item">
            <span class="ward-legend-dot bg-green-500"></span>
            <span class="ward-legend-text">Schedule Route</span>
          </div>
          <div class="ward-legend-item">
            <span class="ward-legend-dot bg-red-500"></span>
            <span class="ward-legend-text">Travelled Route</span>
          </div>
        </div>
        }
      </div>
    </div>
    <div class="ward-map-container" style="position: relative">
      <div id="map"></div>
      <!-- Custom Layer Toggle Button -->
      @if (!showLayerCard) {
      <div class="custom-layer-toggle" (click)="showLayerCard = true">
        <i class="fas fa-layer-group"></i>
      </div>
      }
      <!-- Layer Selection Card -->
      @if (showLayerCard) {
      <div class="layer-selection-card">
        <div class="layer-card-header">
          <span>Select Map Layer</span>
          <i
            class="fas fa-times close-icon"
            (click)="showLayerCard = false"
          ></i>
        </div>
        <div class="layer-options">
          <button
            class="layer-btn"
            [class.active]="selectedLayer === 'street'"
            (click)="setMapLayer('street')"
          >
            Street View
          </button>
          <button
            class="layer-btn"
            [class.active]="selectedLayer === 'osm'"
            (click)="setMapLayer('osm')"
          >
            OSM View
          </button>
          <button
            class="layer-btn"
            [class.active]="selectedLayer === 'sat'"
            (click)="setMapLayer('sat')"
          >
            Satellite View
          </button>
        </div>
      </div>
      }
    </div>
  </div>
</div>
